import React from 'react';

const LoadingIndicator = ({ isVisible, text, color = 'gray' }) => {
    if (!isVisible) return null;

    const colorClasses = {
        gray: 'text-gray-600 border-gray-600',
        blue: 'text-blue-600 border-blue-600',
        green: 'text-green-600 border-green-600',
        yellow: 'text-yellow-600 border-yellow-600',
        red: 'text-red-600 border-red-600',
    };

    const colorClass = colorClasses[color] || colorClasses.gray;

    return (
        <div className={`bg-white ${colorClass} px-3 py-2 rounded-lg shadow-lg flex items-center gap-2 text-sm`}>
            <div className={`animate-spin rounded-full h-4 w-4 border-2 border-t-transparent ${colorClass}`}></div>
            {text}
        </div>
    );
};

export default LoadingIndicator;
